import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { useReviewers, useTable } from "@/stores";

export const usePinStore = defineStore("pin", () => {
  const reviewersStore = useReviewers();
  const tableStore = useTable();

  const searchTerm = ref("");
  const selectedPin = ref(null);
  const error = ref(null);
  const pins = ref([]);

  const searchPins = computed(() => {
    if (!searchTerm.value) {
      return [];
    }

    // Filter pins that contain the search term anywhere in the pin
    const matchingPins = pins.value.filter((pinEl) => {
      if (!pinEl || !pinEl.pin) return false;
      return pinEl.pin.toString().includes(searchTerm.value);
    });

    // Return up to 10 matches
    return matchingPins.slice(0, 10);
  });

  const totalPins = computed(() => pins.value.length);

  async function initializePins() {
    pins.value = await reviewersStore.getReviewerPins();
  }

  async function selectPin(pin) {
    try {
      error.value = null;
      const pinQuery = await reviewersStore.getReviewerByPin(pin);

      if (pinQuery === null || pinQuery.error) {
        error.value = "No reviewer found with that PIN";
        selectedPin.value = null;
        return false;
      }

      // Process the reviewer data to ensure it has the required fields
      const processedReviewer = {
        ...pinQuery,
        emailHash: pinQuery.emailHash || "",
        email: pinQuery.email || "",
        status: pinQuery.status || "",
        rating: pinQuery.rating || "",
      };

      selectedPin.value = processedReviewer;
      // Set the complete reviewer data to the table
      tableStore.setTableData([processedReviewer]);
      searchTerm.value = "";
      return true;
    } catch (err) {
      error.value = "Error fetching reviewer data";
      selectedPin.value = null;
      return false;
    }
  }

  function clearSearch() {
    searchTerm.value = "";
    selectedPin.value = null;
    error.value = null;
  }

  return {
    searchTerm,
    selectedPin,
    error,
    searchPins,
    totalPins,
    selectPin,
    clearSearch,
    initializePins,
    pins,
  };
});
